import React from "react";
import { Text, Spacer, Image, TextSmall } from "../dynamic.components";
import flat_sheets_cassettes_table from "src/assets/images/cassettes/flat_sheets_cassettes_table.png";

export const FlatSheetCassettes: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="The Fluxkart™ provides a convenient way to position the filter holder at the correct height to match the length of the flow kit tubing." />
        <Spacer />
        <Text text="The filter cassette holder follows industry standard cassette dimensions and accepts other cassettes of standard layout. In some cases, an adapter is necessary to connect to the flow kit." />
        <Spacer />
        <Text text="The filter cassette holder mounted on Fluxkart™ can be replaced by other filter cassette holders." />
        <Spacer />
        <Image
          images={[
            {
              src: flat_sheets_cassettes_table,
              alt: "Fiber cartridges",
              customWidth: "60%",
              footer: "* Filter area based on a feed flow of 6–8 L/min/m2",
            },
          ]}
        />
      </div>
    </>
  );
};
